/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import inputStyles from './input'

const {sizes, baseStyle, variants} = inputStyles

export default {
    sizes: {
        md: {...sizes.md.field}
    },
    baseStyle: {
        _focus: baseStyle.field._focus,
        _placeholder: baseStyle._placeholder
    },
    variants: {
        filled: {
            ...variants.filled.field
        },
        flushed: {
            ...variants.flushed.field
        },
        focused: {
            ...variants.focused.field
        },
        accepted: {
            ...variants.accepted.field
        }
    }
}
